import { render } from "./PaymentResultHandler.vue?vue&type=template&id=43ccee58"
import script from "./PaymentResultHandler.vue?vue&type=script&lang=js"
export * from "./PaymentResultHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__